import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const ChannelCellWrapper = styled.div`
  display: grid;
  grid-template-areas:
    'image name'
    'image btn';
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;

  img {
    grid-area: image;
    width: 48px;
    height: 48px;
    object-fit: contain;

    ${mediaQuery.sm} {
      width: 36px;
      height: 36px;
    }
  }

  p {
    grid-area: name;
    font-weight: bold;
    font-size: 18px;
    margin: 0;
  }

  button {
    grid-area: btn;
    padding: 0;
    width: fit-content;
  }
`;
